module.exports = __webpack_public_path__ + "img/jagermeister.48e4debe.svg";